import React, { useState } from "react";

const services = [
  {
    title: "Shopify Plus Store Development",
    paras: [
      "We create Shopify Plus websites that are easy to manage. Our sites are built for great performance. They work well for new businesses and for updating existing stores.",
    ],
    listIntro: "Our development includes:",
    list: [
      "Store architecture",
      "Theme development",
      "Product setup",
      "Collection management",
      "Navigation planning",
      "Performance optimization",
      "Mobile responsiveness",
    ],
    outro:
      "Every store is developed with clean code and future scalability in mind.",
  },
  {
    title: "Shopify Plus Custom Development",
    paras: [
      "Enterprise businesses often require features that go beyond standard Shopify functionality.",
    ],
    listIntro:
      "Our developers build custom solutions that support your daily operations, including:",
    list: [
      "Custom sections",
      "Private applications",
      "Shopify Functions",
      "Checkout extensions",
      "Customer account customization",
      "Business workflow automation",
      "Advanced product options",
      "Wholesale pricing systems",
    ],
    outro:
      "Instead of forcing your business to adapt to software limitations, we build solutions around your workflow.",
  },
  {
    title: "Shopify Plus Migration Services",
    paras: [
      "Moving to Shopify Plus should not interrupt your business.",
      "Our migration specialists carefully transfer your ecommerce store while protecting important business data.",
    ],
    listIntro: "Migration services include:",
    list: [
      "Products",
      "Customers",
      "Orders",
      "Categories",
      "Blogs",
      "Images",
      "SEO URLs",
      "Meta data",
      "Redirects",
      "Collections",
    ],
    outro:
      "We also review your existing website structure to preserve search visibility wherever possible. If you are moving from <a href='/magento-website-development' class='blue-link'>Magento</a>, <a href='/woocommerce-development-services' class='blue-link'>WooCommerce</a>, <a href='/bigcommerce-development-services' class='blue-link'>BigCommerce</a>, OpenCart, Adobe Commerce, or another ecommerce platform, we can help. Our migration process aims to cut downtime.",
  },
  {
    title: "Shopify Plus B2B Development",
    paras: [
      "B2B ecommerce requires features that standard ecommerce stores usually don't have.",
    ],
    listIntro:
      "Our Shopify Plus experts develop wholesale solutions that support:",
    list: [
      "Company accounts",
      "Customer-specific pricing",
      "Volume discounts",
      "Net payment terms",
      "Purchase orders",
      "Bulk ordering",
      "Quick reorder",
      "Custom catalogs",
      "Sales representative workflows",
    ],
    outro:
      "The goal is to simplify purchasing for your business customers while reducing manual work for your internal team.",
  },
  {
    title: "Shopify Plus Integrations",
    paras: [
      "Enterprise businesses rely on multiple systems working together.",
      "Our developers integrate Shopify Plus with your existing software to improve efficiency.",
    ],
    listIntro: "Common integrations include:",
    list: [
      "ERP systems",
      "CRM software",
      "Warehouse management",
      "Inventory systems",
      "Accounting software",
      "Payment gateways",
      "Shipping providers",
      "Marketing automation",
      "Email platforms",
      "Customer support tools",
    ],
    outro:
      "Proper integration reduces duplicate work and helps your business operate more efficiently.",
  },
  {
    title: "Shopify Plus Performance Optimization",
    paras: ["Website speed affects both customer experience and search visibility."],
    listIntro: "Our optimization services focus on improving:",
    list: [
      "Page loading speed",
      "Core Web Vitals",
      "Mobile performance",
      "Image optimization",
      "Theme efficiency",
      "JavaScript optimization",
      "CSS improvements",
      "Store responsiveness",
    ],
    outro:
      "A faster store creates a better shopping experience and helps customers complete purchases more easily.",
  },
  {
    title: "Shopify Plus Support and Maintenance",
    paras: [
      "Launching your store is only the beginning.",
      "We continue supporting your ecommerce business with ongoing improvements, maintenance, and technical assistance.",
    ],
    listIntro: "Our support services include:",
    list: [
      "Store monitoring",
      "Bug fixing",
      "Theme updates",
      "Feature enhancements",
      "Security improvements",
      "Performance reviews",
      "App management",
      "Technical consultation",
    ],
    outro: "Our team remains available as your business grows and your requirements change.",
  },
];

export default function Section5() {
  const [active, setActive] = useState(0);

  return (
    <div className="w-full Section5 py-[30px] bg-[#fff]">
      <div className="w-[92%] md:w-[85%] mx-auto section5-container">
        <div className="w-full flex flex-col md:flex-row items-center gap-y-6 md:gap-x-[5%] pb-[3%]">
          <div className="w-full md:w-[55%] text-center md:text-left">
            <h2 className="text-[26px] md:text-[34px] leading-[32px] md:leading-[41px] text-[#151515] font-bold my-[0.67em]">
              Our Shopify Plus Development Services
            </h2>
            <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open">
              Mean3 is a trusted Shopify Plus development company. We offer
              full development services, from planning to long-term support.
            </p>
          </div>
          <div className="w-full md:w-[35%]">
            <img
              src="/assets/Our Shopify Plus Development Services.webp"
              alt="Our Shopify Plus Development Services"
              className="w-full h-auto"
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-8">
          {/* Tabs list */}
          <div className="w-full md:w-[30%] flex md:flex-col overflow-x-auto md:overflow-visible gap-2 pb-2 md:pb-0">
            {services.map((service, index) => (
              <button
                key={service.title}
                onClick={() => setActive(index)}
                className={`text-left whitespace-nowrap md:whitespace-normal shrink-0 px-4 py-3 rounded-[6px] text-xs md:text-sm font-open font-bold transition-colors ${
                  active === index
                    ? "bg-[#DA2128] text-white"
                    : "bg-white text-[#373737] border border-[#EDEDED] hover:bg-[#F5F5F5]"
                }`}
              >
                {service.title}
              </button>
            ))}
          </div>

          {/* Active panel */}
          <div className="w-full md:w-[70%] bg-white rounded-[8px] p-[6%] md:p-[3%] border border-[#EDEDED]">
            <h3 className="text-[20px] md:text-[25px] font-bold leading-[28px] md:leading-[30px] text-[#DA2128] my-[0.5em] pb-[2%]">
              {services[active].title}
            </h3>

            {services[active].paras.map((p, i) => (
              <p key={i} className="leading-[22px] text-sm md:text-base text-[#373737] mb-4 font-open">
                {p}
              </p>
            ))}

            <p className="leading-[22px] text-sm md:text-base text-[#151515] font-bold mb-3 font-open">
              {services[active].listIntro}
            </p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 mb-4">
              {services[active].list.map((item) => (
                <li key={item} className="flex items-start text-sm md:text-base font-open text-[#373737]">
                  <span className="text-[#DA2128] text-lg leading-[20px] mr-2">•</span>
                  {item}
                </li>
              ))}
            </ul>

            <p
  className="leading-[22px] text-sm md:text-base text-[#373737] font-open"
  dangerouslySetInnerHTML={{ __html: services[active].outro }}
></p>
          </div>
        </div>
      </div>
    </div>
  );
}